import PeppersERC721rAbi from '../abis/PeppersERC721r.json'
import NFTImplementationAbi from '../abis/NFTImplementation.json'
import HabaneroImage from '../assets/images/Collections/Habanero.png'
import LockCollections from '../assets/images/LockCollections.png'
import AnniversaryNfts from '../assets/images/AnniversaryNfts.png'
import moment from 'moment'

export interface INFTCollection {
  displayName: string
  address: string
  coverImage?: string
  image: string
  type?: string
  abi?: any
  description?: any
  descriptionLanding?: any
  featured?: boolean
  campaignSlogan?: string
  isFreeToMint?: boolean
  tokenImageDomain?: string
  maxMintPerAccount?: number
  supportsWhitelist: boolean
  publicMintStartsAt?: moment.Moment
  mintModalWhitelistNote?: any
  isRandom: boolean

  // These are used for pagination on collections page.
  // (there's no need to fetch events from all blocks if minting was only between blocks x & y)
  paginationFromBlock?: number
  paginationToBlock?: number
}

export const collections: { [chainId: number]: INFTCollection[] } = {
  88881: [
    {
      // IPFS json folder: https://chiliz.infura-ipfs.io/ipfs/QmPoQtueJasC5wmmysin8Hja7FAPUUDFMz8Si1u9a1ZpPu/
      // IPFS hidden folder: https://chiliz.infura-ipfs.io/ipfs/QmbqkqWZb68xDqVRkYCwj9jSdWk4hUuNAnaQ789H8yygoB/
      displayName: 'INTG | PEPPERS',
      address: '0xfb9e5dd0e43a26bd019b40f4d7fe5c3e31ce8651',
      coverImage: LockCollections,
      image: LockCollections,
      type: 'ERC721r',
      abi: PeppersERC721rAbi,
      isFreeToMint: false,
      maxMintPerAccount: 1,
      supportsWhitelist: true,
      publicMintStartsAt: moment().utcOffset(60).year(2023).month('february').date(6).hour(15).minute(0).second(1),
      mintModalWhitelistNote: 'Minting will open for whitelisted addresses Wed Feb 01 2023 15:00:00 CET. Public minting will start Mon Feb 06 2023 11:00:00 CET',
      featured: true,
      tokenImageDomain: 'https://chiliz.infura-ipfs.io/ipfs/',
      campaignSlogan: 'Chiliz Scoville NFTs now live on Spicy Testnet',
      description: 'Add some spice to your NFT portfolio with Scoville NFTs, a collection of 10,000 fiery chili peppers that live on Spicy Testnet. Scoville NFTs represent consecutive testnet phases in accordance with the Scoville scale. There are 7 types of chili peppers to collect: Anaheim, Jalapeño, Serrano, Cayenne, Pequin, Malagueta, and Habanero.',
      descriptionLanding: (
        <>
          Add some spice to your NFT portfolio with Scoville NFTs, a collection of 10,000 fiery chili peppers that live on Spicy Testnet. Scoville NFTs represent consecutive testnet phases in accordance with the Scoville scale. There are 7 types of chili peppers to collect: Anaheim, Jalapeño, Serrano, Cayenne, Pequin, Malagueta, and Habanero.
          <br /><br />
          Stage 1: Whitelist Mint for wallets active on Scoville: February 1, 15:00 CET - February 3, 15:00 CET
          <br /><br />
          Stage 2: Public Mint for all wallets: February 6, 11:00 CET - February 9, 11:00 CET
          (Note: Stage 2 will not take place if there are no NFTs leftover from Stage 1)
          <br /><br />
          Stage 3: NFT Reveal: February 9, 15:00 CET
          <br /><br />
          <a href="#faq">Read more…</a>
        </>
      ),
      isRandom: true,
      paginationFromBlock: 8443129
    },
    {
      displayName: 'INTG | Chiliz Anniversary Peppers ‘23',
      address: '0xc729A1BC5c7c5D7e740742Af9fcFb1DFA1DA5cb9',
      coverImage: AnniversaryNfts,
      image: AnniversaryNfts,
      type: 'ERC721r',
      abi: PeppersERC721rAbi,
      isFreeToMint: true,
      maxMintPerAccount: 1,
      supportsWhitelist: false,
      featured: false,
      tokenImageDomain: 'https://chiliz.infura-ipfs.io/ipfs/',
      description: (
        <>
        Chiliz Anniversary Peppers ‘23 is a collection of 100 NFTs living on Spicy Testnet. Chiliz was founded in 2018 and has experienced exponential growth thanks to its dedicated community. This collection was created to commemorate the 5th anniversary of Chiliz and reward its loyal fans with something spicy and fun.
        <br/>
        <br/>
        <strong>Chiliz Timeline:</strong>
        <br/>
        08-02-2018 | Chiliz Founded<br/>
        28-10-2018 | 8,888,888,888 $CHZ Minted<br/>
        29-10-2019 | Minting first Fan Token<br/>
        06-11-2019 | Launch of Socios App<br/>
        31-03-2022 | Launch of Scoville Testnet<br/>
        08-02-2023 | Chiliz 5th Anniversary<br/>
        08-02-2023 | Chiliz unveils new branding<br/>
        </>
      ),
      isRandom: true,
      paginationFromBlock: 8610448,
      paginationToBlock: 8610448
    }
  ],
  88880: [
    {
      displayName: 'CHZNFT1',
      address: '0xdC50294C5dC2F0111cfCbB1d2823cA7446072892',
      image: HabaneroImage,
      type: 'ERC721',
      abi: NFTImplementationAbi,
      description: 'sed. Eu cras eu nec, vel nibh. Cras neque et condimentum vestibulum amet, habitant. Viverra ut sed vulputate vel venenatis viverra. Leo turpis egetaccumsan vitae egestas lobortis ornare.',
      isFreeToMint: true,
      featured: true,
      campaignSlogan: 'New Era 1',
      tokenImageDomain: 'https://chiliz.infura-ipfs.io/ipfs/',
      maxMintPerAccount: 1,
      supportsWhitelist: false,
      isRandom: false
    },
    {
      displayName: 'CHZNFT2',
      address: '0x78373d699EF6a4BAEB5202c6cDc87629A38c57c1',
      image: HabaneroImage,
      type: 'ERC721',
      abi: NFTImplementationAbi,
      isFreeToMint: true,
      tokenImageDomain: 'https://chiliz.infura-ipfs.io/ipfs/',
      maxMintPerAccount: 1,
      supportsWhitelist: false,
      isRandom: false
    },
    {
      displayName: 'CHZNFT3',
      address: '0x11E9C4B9FCE640c094e6f853B08773cb2561835b',
      image: HabaneroImage,
      type: 'ERC721',
      abi: NFTImplementationAbi,
      isFreeToMint: true,
      tokenImageDomain: 'https://chiliz.infura-ipfs.io/ipfs/',
      maxMintPerAccount: 1,
      supportsWhitelist: false,
      isRandom: false
    },
    {
      displayName: 'CHZNFT4',
      address: '0x520023B2715dc05D6A57bE2C7529dA49A4Fc7193',
      image: HabaneroImage,
      type: 'ERC721',
      abi: NFTImplementationAbi,
      isFreeToMint: true,
      tokenImageDomain: 'https://chiliz.infura-ipfs.io/ipfs/',
      maxMintPerAccount: 1,
      supportsWhitelist: false,
      isRandom: false
    },
    {
      displayName: 'CHZNFT5',
      address: '0xB82cbf5F9346140217c4D2d9ab38A40CB4c28aB0',
      image: HabaneroImage,
      type: 'ERC721',
      abi: NFTImplementationAbi,
      isFreeToMint: true,
      tokenImageDomain: 'https://chiliz.infura-ipfs.io/ipfs/',
      maxMintPerAccount: 1,
      supportsWhitelist: false,
      isRandom: false
    }
  ],
  88882: [{
    displayName: 'Scoville NFTs | Spicy Peppers',
    address: '0xCc656A28d656bBb8B45eC450d43bEd4226fc167f',
    coverImage: LockCollections,
    image: LockCollections,
    type: 'ERC721r',
    abi: PeppersERC721rAbi,
    isFreeToMint: false,
    maxMintPerAccount: 1,
    supportsWhitelist: true,
    publicMintStartsAt: moment().utcOffset(60).year(2023).month('february').date(6).hour(11).minute(0).second(0),
    mintModalWhitelistNote: 'Minting will open for whitelisted addresses Wed Feb 01 2023 17:00:00 CET. Public minting will start Mon Feb 06 2023 11:00:00 CET',
    featured: true,
    tokenImageDomain: 'https://chiliz.infura-ipfs.io/ipfs/',
    campaignSlogan: 'Chiliz Scoville NFTs now live on Spicy Testnet',
    description: 'Add some spice to your NFT portfolio with Scoville NFTs, a collection of 10,000 fiery chili peppers that live on Spicy Testnet. Scoville NFTs represent consecutive testnet phases in accordance with the Scoville scale. There are 7 types of chili peppers to collect: Anaheim, Jalapeño, Serrano, Cayenne, Pequin, Malagueta, and Habanero.',
    descriptionLanding: (
      <>
        Add some spice to your NFT portfolio with Scoville NFTs, a collection of 10,000 fiery chili peppers that live on Spicy Testnet. Scoville NFTs represent consecutive testnet phases in accordance with the Scoville scale. There are 7 types of chili peppers to collect: Anaheim, Jalapeño, Serrano, Cayenne, Pequin, Malagueta, and Habanero.
        <br /><br />
        Stage 1: Whitelist Mint for wallets active on Scoville: February 1, 17:00 CET - February 3, 17:00 CET
        <br /><br />
        Stage 2: Public Mint for all wallets: February 6, 11:00 CET - February 9, 11:00 CET
        (Note: Stage 2 will not take place if there are no NFTs leftover from Stage 1)
        <br /><br />
        Stage 3: NFT Reveal: February 9, 15:00 CET
        <br /><br />
        <a href="#faq">Read more…</a>
      </>
    ),
    isRandom: true,
    paginationFromBlock: 600858,
    paginationToBlock: 605782
  },
  {
    displayName: 'Chiliz Anniversary Peppers ‘23',
    address: '0xCC9e5A8d8005D4915b6d51E547a5B73F07fEFf03',
    coverImage: AnniversaryNfts,
    image: AnniversaryNfts,
    type: 'ERC721r',
    abi: PeppersERC721rAbi,
    isFreeToMint: true,
    maxMintPerAccount: 1,
    supportsWhitelist: false,
    featured: false,
    tokenImageDomain: 'https://chiliz.infura-ipfs.io/ipfs/',
    description: (
      <>
      Chiliz Anniversary Peppers ‘23 is a collection of 100 NFTs living on Spicy Testnet. Chiliz was founded in 2018 and has experienced exponential growth thanks to its dedicated community. This collection was created to commemorate the 5th anniversary of Chiliz and reward its loyal fans with something spicy and fun.
      <br/>
      <br/>
      <strong>Chiliz Timeline:</strong>
      <br/>
      08-02-2018 | Chiliz Founded<br/>
      28-10-2018 | 8,888,888,888 $CHZ Minted<br/>
      29-10-2019 | Minting first Fan Token<br/>
      06-11-2019 | Launch of Socios App<br/>
      31-03-2022 | Launch of Scoville Testnet<br/>
      08-02-2023 | Chiliz 5th Anniversary<br/>
      08-02-2023 | Chiliz unveils new branding<br/>
      </>
    ),
    isRandom: true,
    paginationFromBlock: 797192,
    paginationToBlock: 797293
  }
  ]
}
